<div>
    <div class="flex items-center mb-1">
        <mat-icon svgIcon="heroicons_outline:x-circle" matTooltip="Cerrar" class="close-button" mat-dialog-close
            style="cursor: pointer;"></mat-icon>
    </div>

    <h2 mat-dialog-title class="text-lg font-bold mb-1">{{this.data.data.material.code}} - {{this.data.data.material.name}}</h2>
    <app-manual-label-selection-indicator
      [manuallySelected]="data.data.deliveryLabelsManuallySelect === true"
      [showText]="true"
      class="mb-2 flex items-center"
    ></app-manual-label-selection-indicator>
    <mat-dialog-content class="modal-content">
    <div class="flex flex-wrap gap-x-8 gap-y-2 p-2 border border-gray-200 rounded bg-gray-50 mb-4 text-sm text-black">
        <p *ngIf="!data.order.orders"><strong>Nro Doc:</strong> {{ data.order.serial }}</p>
        <p><strong>Cantidad UMB:</strong> {{ data.data.baseQuantity || data.order.baseQuantity }}</p>
        <p><strong>Cantidad UMP:</strong> {{ data.data.pararellQuantity || data.order.pararellQuantity }}</p>
    </div>
        <div class="top-0">
            <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceBatches"
                matSort multiTemplateDataRows>
                <ng-container matColumnDef="batch">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Lote</th>
                    <td mat-cell *matCellDef="let batches" class="px-6 text-left">
                        <ng-container *ngIf="data?.isEdit; else viewBacth">
                            <input
                            [(ngModel)]="batches.bacth"
                            class="w-32 border rounded px-2 py-2 text-right focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
                            [ngModelOptions]="{standalone: true}" />
                        </ng-container>
                        <ng-template #viewBacth>
                            {{batches?.bacth}}
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="umb">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Cantidad UMB</th>
                    <td mat-cell *matCellDef="let batches" class="px-6 text-left">
                        <ng-container *ngIf="data?.isEdit; else viewUMB">
                            <input type="number"
                            [(ngModel)]="batches.quantity"
                            (ngModelChange)="onQuantityParallelChange(batches)"
                            class="w-24 border rounded px-2 py-2 text-right focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
                            [ngModelOptions]="{standalone: true}" />
                        </ng-container>
                        <ng-template #viewUMB>
                            {{batches?.quantity | number: '1.3'}}
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ump">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Cantidad UMP</th>
                    <td mat-cell *matCellDef="let batches" class="px-6 text-left">
                        <ng-container *ngIf="data?.isEdit; else viewUMP">
                            <input type="number"
                            [(ngModel)]="batches.parallelQuantity"
                            class="w-24 border rounded px-2 py-2 text-right focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
                            [ngModelOptions]="{standalone: true}" />
                        </ng-container>
                        <ng-template #viewUMP>
                            {{batches?.parallelQuantity | number: '1.3'}}
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="warehouse">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Almacén Destino</th>
                    <td mat-cell *matCellDef="let batches" class="px-6 text-left">
                        <ng-container *ngIf="data?.isEdit; else viewWarehouse">
                            <mat-select [(ngModel)]="batches.warehouse"
                            class="w-48 border rounded px-2 py-2 focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
                            [ngModelOptions]="{standalone: true}">
                                <mat-option *ngFor="let warehouses of warehouseList" [value]="warehouses._id">{{ warehouses.name }}</mat-option>
                            </mat-select>
                        </ng-container>
                        <ng-template #viewWarehouse>
                            -
                        </ng-template>
                    </td>
                </ng-container>
                  
                <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                        Facturas (Precio)
                        <button mat-button color="primary" [disabled]="!canEdit" (click)="openInvoiceDialog()">
                            {{hasAnyInvoiceSelected() ?  'Cambiar' : 'Seleccionar'}}
                        </button>
                    </th>
                    <td mat-cell *matCellDef="let batches" class="px-6 text-left">
                      <ng-container *ngIf="data?.isEdit">
                        <span *ngIf="batches.invoice">
                            {{ batches.invoice.facture }} ( {{ batches.invoice.price}} )
                        </span>
                        <!-- <button mat-button color="primary" (click)="openInvoiceDialog(batches)" [disabled]="hasAnyInvoiceSelected() && !batches.invoice">
                          {{batches.invoice ?  'Cambiar' : 'Seleccionar'}}
                        </button> -->
                      </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="expand">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let batches">
                        <ng-container *ngIf="batches?.labels && batches?.labels?.length > 0">
                            <button mat-icon-button (click)="batches.expanded = !batches.expanded">
                                <mat-icon>{{batches.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
                            </button>
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="text-left">
                      <ng-container *ngIf="data?.isEdit; else viewUMP">
                        <button mat-icon-button color="primary" [disabled]="!canEdit" (click)="addNewBatch()" matTooltip="Añadir lote">
                            <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                        </button>
                    </ng-container>
                    </th>
                    <td mat-cell *matCellDef="let batches; let i = index" class="text-left">
                        <ng-container *ngIf="data?.isEdit; else viewUMP">
                            <button mat-icon-button color="primary" [disabled]="!canEdit" (click)="addLabelToBatch(batches, i)" matTooltip="Añadir etiqueta">
                                <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                            </button>
                            <button mat-icon-button color="warn" [disabled]="!canEdit" (click)="deleteBatch(i)" matTooltip="Eliminar lote">
                                <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                            </button>
                
                        </ng-container>
                        <ng-template #viewUMP>
                            <button mat-icon-button>
                                <mat-icon>delete</mat-icon>
                            </button>
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="nestedTable">
                    <td mat-cell *matCellDef="let batches" [attr.colspan]="displayedColumnsBatches.length">
                        <div *ngIf="batches?.labels && batches?.labels?.length > 0" class="tablein overflow-hidden"
                            [@detailExpand]="batches.expanded ? 'expanded' : 'collapsed'">
                            <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table
                                [dataSource]="batches.labels" class="w-full nested-table">
                                <ng-container matColumnDef="batch">
                                    <th mat-header-cell *matHeaderCellDef class="text-left">Etiqueta</th>
                                    <td mat-cell *matCellDef="let nestedItem" class="text-left">
                                        <ng-container *ngIf="data?.isEdit; else viewLabel">
                                            <input
                                            [(ngModel)]="nestedItem.label"
                                            class="w-32 border rounded px-2 py-2 text-right focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
                                            [ngModelOptions]="{standalone: true}" />
                                        </ng-container>
                                        <ng-template #viewLabel>
                                            {{nestedItem?.label}}
                                        </ng-template>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="umb">
                                    <th mat-header-cell *matHeaderCellDef class="text-left">Cantidad UMB</th>
                                    <td mat-cell *matCellDef="let nestedItem" class="text-left">
                                        <ng-container *ngIf="data?.isEdit; else viewNestedUMB">
                                            <input type="number"
                                            [(ngModel)]="nestedItem.quantity"
                                            class="w-24 border rounded px-2 py-2 text-right focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
                                            [ngModelOptions]="{standalone: true}" />
                                        </ng-container>
                                        <ng-template #viewNestedUMB>
                                            {{nestedItem?.quantity | number: '1.3'}}
                                        </ng-template>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="ump">
                                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Cantidad UMP</th>
                                    <td mat-cell *matCellDef="let nestedItem" class="px-6 text-left">
                                        <ng-container *ngIf="data?.isEdit; else viewUMP">
                                            <input type="number"
                                            [(ngModel)]="nestedItem.parallelQuantity"
                                            class="w-24 border rounded px-2 py-2 text-right focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
                                            [ngModelOptions]="{standalone: true}" />
                                        </ng-container>
                                        <ng-template #viewUMP>
                                            {{nestedItem?.parallelQuantity | number: '1.3'}}
                                        </ng-template>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef class="text-left">Acciones</th>
                                    <td mat-cell *matCellDef="let nestedItem; let i = index" class="text-left">
                                        <ng-container *ngIf="data?.isEdit; else viewUMP">
                                        <button mat-icon-button color="warn" [disabled]="!canEdit" (click)="deleteLabel(batches, i)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </ng-container>
                                    <ng-template #viewUMP>
                                        <button mat-icon-button>
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </ng-template>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail" class="bg-gray-100"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail; let i = index"
                                [trackBy]="trackByLabelFn" ></tr>
                            </table>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsBatches" class="bg-gray-100"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsBatches; let i = index"
                 [trackBy]="trackBy" class="border-b"></tr>

                <tr mat-row *matRowDef="let row; columns: ['nestedTable']" class="table-detail-row"></tr>
            </table>
            <ng-container *ngIf="dataSourceBatches.data && dataSourceBatches.data.length === 0">
                <div class="flex justify-center items-center h-32">
                    <p class="text-gray-500">No hay lotes disponibles</p>
                </div>
            </ng-container>
        </div>
    </mat-dialog-content>

    @if(data?.isEdit){
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button class="align-left" (click)="onClose()">Cancelar</button>
        <button mat-raised-button color="primary" [disabled]="!canEdit" (click)="onSubmit()">Guardar</button>
    </mat-dialog-actions>
    }
</div>

<ng-template #invoiceModal let-data>
    <h2 mat-dialog-title>Seleccionar Factura</h2>
  
    <mat-dialog-content>
        @if(invoiceList?.length > 0){
        <mat-selection-list>
            <mat-list-option *ngFor="let invoice of invoiceList"
                (click)="selectInvoice(invoice)"
                [class.selected]="selectedInvoice === invoice">
                <div class="invoice-item flex justify-between items-center">
                    <span class="font-semibold">{{ invoice.facture }}</span>
                    <span class="text-sm">Precio: {{ invoice.price }}</span>
                </div>
            </mat-list-option>
        </mat-selection-list>
        }@else{
            <p class="text-gray-500 items-center">No hay facturas disponibles</p>
        }
    </mat-dialog-content>
  
    <mat-dialog-actions align="end">
      <button mat-button (click)="dialogInvoiceRef.close()">Cerrar</button>
    </mat-dialog-actions>
</ng-template>
  